module.exports = __webpack_public_path__ + "static/media/conf.2a530cc0.jpg";